import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useGetDeviceElevatorIntegrationData } from './useGetDeviceElevatorIntegrationData';

export function useGetGlobalHooks() {
  const { elevatorIntegrationSettings: deviceElevatorIntegration } = useGetDeviceElevatorIntegrationData();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  return {
    deviceElevatorIntegration,
    dispatch,
    formatMessage,
  };
}
